import React from "react";
import { FaCheck, FaPlus, FaTimes } from "react-icons/fa";

function FieldLabel({ children }) {
  return (
    <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-slate-400">
      {children}
    </span>
  );
}

function ExerciseFormCard({
  form,
  editingExercise,
  saving,
  onChange,
  onSubmit,
  onCancel,
}) {
  return (
    <article className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.16em] text-emerald-600 dark:text-emerald-200">
          {editingExercise ? "Modification" : "Nouvel exercice"}
        </p>

        <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
          {editingExercise ? "Modifier l'exercice" : "Créer un exercice"}
        </h2>

        <p className="mt-2 text-sm font-medium leading-6 text-slate-500 dark:text-white/50">
          Décris l'exercice, ajoute une photo, une vidéo ou un programme simple.
        </p>
      </div>

      <form onSubmit={onSubmit} className="mt-5 space-y-4">
        <label className="block">
          <FieldLabel>Nom de l'exercice *</FieldLabel>

          <input
            type="text"
            name="nom"
            value={form.nom}
            onChange={onChange}
            placeholder="Ex : Gainage ventral"
            className="h-12 w-full rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-emerald-300 focus:ring-4 focus:ring-emerald-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-emerald-300/50 dark:focus:ring-emerald-500/10"
          />
        </label>

        <label className="block">
          <FieldLabel>Description</FieldLabel>

          <textarea
            name="description"
            value={form.description}
            onChange={onChange}
            rows={4}
            placeholder="Consignes techniques, posture, sécurité..."
            className="w-full resize-none rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium leading-7 text-slate-700 outline-none transition placeholder:text-slate-400 focus:border-emerald-300 focus:ring-4 focus:ring-emerald-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-emerald-300/50 dark:focus:ring-emerald-500/10"
          />
        </label>

        <label className="block">
          <FieldLabel>Programme</FieldLabel>

          <input
            type="text"
            name="programme"
            value={form.programme}
            onChange={onChange}
            placeholder="Ex : 3 séries de 30 secondes, repos 45 secondes"
            className="h-12 w-full rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-emerald-300 focus:ring-4 focus:ring-emerald-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-emerald-300/50 dark:focus:ring-emerald-500/10"
          />
        </label>

        <div className="grid gap-4 sm:grid-cols-2">
          <label className="block">
            <FieldLabel>URL photo</FieldLabel>

            <input
              type="url"
              name="lien_photo"
              value={form.lien_photo}
              onChange={onChange}
              placeholder="https://..."
              className="h-12 w-full rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-emerald-300 focus:ring-4 focus:ring-emerald-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-emerald-300/50 dark:focus:ring-emerald-500/10"
            />
          </label>

          <label className="block">
            <FieldLabel>URL vidéo</FieldLabel>

            <input
              type="url"
              name="lien_video"
              value={form.lien_video}
              onChange={onChange}
              placeholder="https://..."
              className="h-12 w-full rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 outline-none transition focus:border-emerald-300 focus:ring-4 focus:ring-emerald-100 dark:border-white/10 dark:bg-slate-950 dark:text-white dark:focus:border-emerald-300/50 dark:focus:ring-emerald-500/10"
            />
          </label>
        </div>

        <div className="grid gap-2 sm:grid-cols-2">
          <button
            type="submit"
            disabled={saving}
            className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-emerald-700 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
          >
            {editingExercise ? <FaCheck /> : <FaPlus />}
            {saving ? "Enregistrement..." : editingExercise ? "Modifier" : "Créer"}
          </button>

          {editingExercise && (
            <button
              type="button"
              onClick={onCancel}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-5 py-3 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 dark:border-white/10 dark:bg-white/[0.05] dark:text-white"
            >
              <FaTimes />
              Annuler
            </button>
          )}
        </div>
      </form>
    </article>
  );
}

export default ExerciseFormCard;